import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import CountriesActions, { CountriesRedux, CountriesTypes } from '../Redux/CountriesRedux'

const CountriesCRUDObservable = createCRUDObservable({
  mainRedux: CountriesRedux,
  reduxPath: 'countries',
})

export const CountriesObservers = Object.assign({}, CountriesCRUDObservable.observers, {})


export const CountriesEpic = combineEpics(
  CountriesCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CountriesObservable.js